<template>
    <ul class="mainmenu">
			  <li><router-link to="/">首页</router-link></li>
			<li class="with-megamenu has-menu-child-item">
				<a href="#">
					产品及服务
					<Icon name="plus" class="collapse-icon plus"/>
					<Icon name="minus" class="collapse-icon minus"/>
				</a>
				<div class="rn-megamenu">
					<div class="wrapper">
						<div class="subnav-container" style="padding: 20px;display: inline-block;width: 100%;height: 210px">
							<div class="subnav-left-box">
								<ul>
									<li @mouseenter="onMouseEnter(1)" :class="{'active': hoverId === 1}"><a>AI</a></li>
									<li @mouseenter="onMouseEnter(2)" :class="{'active': hoverId === 2}"><a>数据</a></li>
									<li @mouseenter="onMouseEnter(3)" :class="{'active': hoverId === 3}"><a>基础架构软硬件</a></li>
									<li @mouseenter="onMouseEnter(4)" :class="{'active': hoverId === 4}"><a>安全服务</a></li>
								</ul>
							</div>
							<div class="subnav-right-box clearfix">
								<ul v-if="hoverId === 1" class="clearfix">
									<li>
										<div class="t-title">产品及解决方案</div>
										<div class="three-nav-side">
											<dl>
												<dd><router-link to="/chergpt">CherGPT—AI原生赋能平台</router-link></dd>
											</dl>
										</div>
									</li>
									<li>
										<div class="t-title">服务</div>
										<div class="three-nav-side">
											<dl>
												<dd><router-link to="/ai">AI服务</router-link></dd>
											</dl>
										</div>
									</li>
								</ul>
								<ul v-else-if="hoverId === 2" class="clearfix">
									<li>
										<div class="t-title">产品及解决方案</div>
										<div class="three-nav-side">
											<dl>
												<dd><router-link to="/dscp">数据安全管控平台</router-link></dd>
												<dd><router-link to="/cdp">客户数据平台</router-link></dd>
											</dl>
										</div>
									</li>
									<li>
										<div class="t-title">服务</div>
										<div class="three-nav-side">
											<dl>
												<dd><router-link to="/data-service1">数据治理咨询与实施服务</router-link></dd>
												<dd><router-link to="/data-service2">数字化应用开发</router-link></dd>
											</dl>
										</div>
									</li>
								</ul>
								<ul v-else-if="hoverId === 3" class="clearfix" style="width: 100%">
									<li>
										<div class="t-title">产品及解决方案</div>
										<div class="three-nav-side">
											<dl>
												<dd><router-link to="/base">所有产品</router-link></dd>
											</dl>
										</div>
									</li>
								</ul>
								<ul v-else-if="hoverId === 4" class="clearfix" style="width: 100%">
									<li>
										<div class="t-title">产品及解决方案</div>
										<div class="three-nav-side">
											<dl>
												<dd><router-link to="/cloud-safety">云安全</router-link></dd>
												<dd><router-link to="/device-safety">终端安全</router-link></dd>
												<dd><router-link to="/mail-safety">邮件安全</router-link></dd>
											</dl>
										</div>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</li>
        <li class="has-droupdown has-menu-child-item">
            <a href="#">
							行业解决方案
                <Icon name="plus" class="collapse-icon plus"/>
                <Icon name="minus" class="collapse-icon minus"/>
            </a>
            <ul class="submenu">
                <li><router-link to="/solution1">金融</router-link></li>
                <li><router-link to="/solution2">运营商</router-link></li>
                <li><router-link to="/solution3">制造</router-link></li>
            </ul>
        </li>
        <li><router-link to="/about">关于我们</router-link></li>
    </ul>
</template>

<script>
    import Icon from "../../icon/Icon";
		import {h} from "vue";
    export default {
        name: 'Nav',
        components: {Icon},
				data() {
						return {
							hoverId: 1
						}
				},
				methods: {
					h,
					onMouseEnter(idx){
						this.hoverId = idx;
					}
				}
    }
</script>
<style lang="scss" scoped>
	.subnav-container {
		&::before {
			content: '';
			width: 20%;
			height: 100%;
			background: -webkit-linear-gradient(to left, #94c6ff, transparent);
			background: linear-gradient(to left, #94c6ff, transparent);
			position: absolute;
			top: 0;
			left: 0;
		}
	}
	.subnav-left-box {
		float: left;
		width: 20%;
		text-align: left;
		padding-left: 5%;
		position: initial;
		ul {
			list-style: none outside none;
			padding: 0;
			margin: 0;
			padding-inline-start: 0;
		}
		li {
			font-size: 18px;
			line-height: 1.2;
			padding: 12px 0;
			a {
				display: block;
				color: #636363;
				font-size: 16px;
				cursor: pointer;
			}
			&.active a {
				font-weight: bold;
			}
		}
	}
	.subnav-right-box {
		padding: 0 10% 0 0;
		float: right;
		width: 80%;
		font-size: 16px;
		ul {
			display: flex;
			li {
				width: 50%;
				flex: 1;
				float: left;
				padding: 0 18px;
				font-size: 18px;
				line-height: 1.2;
				margin: 12px 0;

				.t-title {
					font-size: 16px;
					font-weight: bold;
					position: relative;
				}

				dl {
					margin-top: 20px;
					dd {
						margin-left: 0;
						margin-top: 16px;
						font-size: 16px;
					}
				}
			}
		}
	}
	.clearfix {
		display: block;
	}
	a {
		color: #65676b;
	}
</style>
